import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1451.06 557.975C1456.76 557.082 1462.44 556.191 1468.24 556.191C1717.38 556.191 1920 761.334 1920 1013.33C1920 1265.33 1717.38 1470.48 1468.24 1470.48H1016.47V1094.13L1202.37 1282.36L1282.33 1201.45L960 875.391L637.666 1201.45L717.628 1282.36L903.529 1094.13V1470.48H395.294C177.318 1470.48 0 1291.05 0 1070.48C0 849.905 177.318 670.477 395.294 670.477C416.188 670.477 436.631 673.22 456.847 676.534C482.598 417.105 697.073 213.334 960 213.334C1181.82 213.334 1368.85 358.705 1438.08 559.62C1442.45 559.325 1446.76 558.649 1451.06 557.975ZM1016.47 1813.33H903.53V1470.48H1016.47V1813.33Z",
  fillRule: "evenodd"
});

var IconCloudUploadSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCloudUploadSolid, _Component);

  var _super = _createSuper(IconCloudUploadSolid);

  function IconCloudUploadSolid() {
    _classCallCheck(this, IconCloudUploadSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCloudUploadSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCloudUpload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCloudUploadSolid.displayName = "IconCloudUploadSolid";
  return IconCloudUploadSolid;
}(Component);

IconCloudUploadSolid.glyphName = 'cloud-upload';
IconCloudUploadSolid.variant = 'Solid';
IconCloudUploadSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCloudUploadSolid;
export { IconCloudUploadSolid };